<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    hasButton: {
      type: Boolean,
      required: true
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      required: true
    },
    nome: {
      type: String,
      default: 'autorenew'
    },
    rotateButton: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      current: 0
    }
  }

}
</script>

<template>
  <div>
    <el-row
      type="flex"
      justify="space-between"
      align="bottom"
    >
      <div class="flex">
        <p class="label">
          {{ label }}
          <span v-if="required" class="required">&nbsp;*</span>
        </p>
        <slot name="info" />
      </div>

      <el-tooltip
        class="item"
        effect="dark"
        :content="content"
        placement="left"
      >
        <el-button
          v-if="hasButton && rotateButton"
          class="btn"
          type="text"
          v-action-rotate="true"
          @click="$emit('click')"
          size="mini"
        >
          <i v-if="nome" class="material-icons">{{ nome }}</i>
        </el-button>

        <el-button
          v-if="hasButton && !rotateButton"
          class="btn"
          type="text"
          @click="$emit('click')"
          size="mini"
        >
          <i v-if="nome" class="material-icons">{{ nome }}</i>
        </el-button>
      </el-tooltip>
    </el-row>

    <el-row>
      <div class="divider" v-if="showBorder"></div>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Buttons/RefreshButton/RefreshButton.vue